@if (menuActionsOptions.length !== 1 || forceUsingSelectOptions) {
    <app-select
        class="actions"
        placeHolder="Actions"
        [options]="menuActionsOptions"
        (optionOnSelection)="onSelection($event)"
        [withoutShowingSelection]="true">
    </app-select>
}
@if (menuActionsOptions.length === 1 && !forceUsingSelectOptions) {
    <div
        class="single-action"
        (click)="onSelection(menuActionsOptions[0])">
        <img [src]="menuActionsOptions[0].iconPath" />
        {{ menuActionsOptions[0].displayName }}
    </div>
}
